import { render } from "./HistoryHeader.vue?vue&type=template&id=9009e2d8"
import script from "./HistoryHeader.vue?vue&type=script&lang=js"
export * from "./HistoryHeader.vue?vue&type=script&lang=js"
script.render = render

export default script